import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Login from "../components/User/LoginForm";
import { AnimatePresence, motion } from "framer-motion";
import { ToastContainer } from "react-toastify";
import { clearProgramUploads } from "../features/programUpload";
import { clearProgramFields } from "../features/programField";
import { clearPrograms } from "../features/program";
import { clearValues } from "../features/applicationValue";
import { clearApplications } from "../features/application";
import { clearDropdownValues } from "../features/dropdownValue";
import { clearApplicationProperties } from "../features/applicationProperties";
import { clearApplicationStatus } from "../features/applicationStatus";
import { clearProperties } from "../features/properties";
import { clearStatusList } from "../features/status";
import { logout } from "../features/user";
import { logoutCustomer } from "../features/customer";

import "react-toastify/dist/ReactToastify.css";

const AdminLoginPage = () => {
  const dispatch = useDispatch();

  const clearRedux = () => {
    dispatch(logout());
    dispatch(logoutCustomer());
    localStorage.clear();
    dispatch(clearProperties());
    dispatch(clearStatusList());
    dispatch(clearProgramUploads());
    dispatch(clearProgramFields());
    dispatch(clearPrograms());
    dispatch(clearValues());
    dispatch(clearApplications());
    dispatch(clearApplicationStatus());
    dispatch(clearDropdownValues());
    dispatch(clearApplicationProperties());
  };

  return (
    <AnimatePresence exitBeforeEnter initial={false}>
      <ToastContainer key="toast" theme="light" />
      <motion.div
        key="main"
        className="flex h-screen transform justify-center bg-cover transition duration-200 md:bg-[#7d7d7d]"
      >
        <div className="hidden w-full font-sans text-white md:flex md:flex-col md:items-center md:justify-center md:gap-1 md:text-3xl">
          <div className="md:flex md:h-full md:w-full md:max-w-4xl md:flex-col md:items-center md:bg-ws md:bg-[length:70%] md:bg-center md:bg-no-repeat md:aspect-square lg:aspect-video xl:max-w-5xl"></div>
        </div>
        <motion.div className="relative flex w-full md:w-6/12 flex-col items-center justify-center gap-4 md:gap-8 bg-white px-0 md:px-4">
          <div className="flex h-[68px] w-[282px] md:h-[4rem] md:w-[16rem] bg-test1 bg-cover bg-center md:mt-4"></div>
          <div className="w-full max-w-md md:max-w-none">
            <Login
              props={{
                type: "ADMIN",
              }}
            />
          </div>
          <div className="landing-btns flex flex-col gap-4 p-2 text-sm"></div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default AdminLoginPage;
